<template>
    <div id="slide_box">
        <div id="slide_content" :style="{background: siteCodeInfo[0].BACK_COLOR}">
            <div class="slide_block" id="slide2" :class="getShowClass()">
                <div class="slide_animate_block">
                    <div class="category" id="big">
                        <form @submit.prevent="submitLargeItems">
                            <div class="bg" :style="{background: siteCodeInfo[0].BACK_COLOR}">
                                <div class="wrap03 stitle_box">
                                    <h2 class="stitle">
                                        <span v-html="siteCodeInfo[0].LARGE_WORD1_PC"></span>
                                    </h2>
                                    <p class="commonError" v-if="error">{{$msg.ERROR.MSG_1004}}</p>
                                    <CommonErrorMsgArea v-else/>
                                </div>
                                <div class="wrap01 form_box">
                                    <p class="caution_txt_01">※複数選択可能</p>
                                    <p class="comment_txt_01" v-html="siteCodeInfo[0].LARGE_WORD2_PC"></p>
                                    <div v-for="item in items" :key="item.code" class="form_block_06" :id="item.id">
                                        <div class="radio_box">
                                            <div class="img_box">
                                                <p class="img">
                                                    <img :src="item.image" :alt="item.name">
                                                </p>
                                            </div>
                                            <div class="form-Radio-02 radio_no">
                                                <label><input type="radio" :name="item.name" @click="isExist(false, item)" :checked="item.unit == 0"><span class="input_txt" :style="{backgroundColor :item.unit == 0? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :item.unit == 0? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">無し</span></label>
                                                <label><input type="radio" :name="item.name" @click="isExist(true, item)" :checked="item.unit > 0"><span class="input_txt" :style="{backgroundColor :item.unit > 0? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :item.unit > 0? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">有り</span></label>
                                            </div>
                                        </div>
                                        <div v-if="item.unit > 0" class="no_boxs open">
                                            <div class="item_description_l1" v-html="displayItemDescription(item)"></div>
                                            <div v-for="n in item.unit" :key="n" class="no_block open" :id="item.code+'_'+n">
                                                <p v-if="n == 1" class="no_txt open" @click="deleteUnit(item, n)" >{{ item.name }}{{ n }}台目<span v-if="item.unit > 1" class="icon"></span></p>
                                                <p v-else class="no_txt" :class="{'open': n <= item.unit}" @click="deleteUnit(item, n)">{{ item.name }}{{ n }}台目<span class="icon"></span></p>
                                                <div class="radio_boxs open">
                                                    <div class="maker_box">
                                                        <div class="bg_box">
                                                            <p class="title">メーカーを選択</p>
                                                            <div class="form-Radio-02 label_box">
                                                                <label v-for="maker in item.makerList" :key="maker.CODE">
                                                                    <input type="radio" :name="item.code + '_'+ n + '_maker'" :value="maker" @change="getSize(item, n)"
                                                                    v-model="item.selectedMakerSizeList[n-1].selectedMaker">
                                                                    <span class="input_txt" :style="{backgroundColor :maker == item.selectedMakerSizeList[n-1].selectedMaker? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :maker == item.selectedMakerSizeList[n-1].selectedMaker? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ maker.CODE_NM }}</span>
                                                                </label>
                                                            </div>
                                                            <p class="error" style="text-align:center" v-if="item.selectedMakerSizeList[n-1].required_maker">{{$msg.ERROR.MSG_0019}}</p>
                                                        </div>
                                                    </div>
                                                    <div v-if = "item.sizeLists[n-1].sizeList.length > 0" class="size_box">
                                                        <div class="bg_box">
                                                            <p class="title">大きさを選択</p>
                                                            <div class="form-Radio-02 label_box">
                                                                <label v-for="size in item.sizeLists[n-1].sizeList" :key="size.CODE">
                                                                    <input type="radio" :name="item.code + '_'+ n + '_size'" :value="size"
                                                                    v-model="item.selectedMakerSizeList[n-1].selectedSize">
                                                                    <span class="input_txt" :style="{backgroundColor :size == item.selectedMakerSizeList[n-1].selectedSize? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :size == item.selectedMakerSizeList[n-1].selectedSize? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ size.CODE_NM }}</span>
                                                                </label>
                                                            </div>
                                                            <p class="error" style="text-align:center" v-if="item.selectedMakerSizeList[n-1].required_size">{{$msg.ERROR.MSG_0020}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="size_box" v-if="item.removalWorkLists && item.removalWorkLists[n-1].removalWorkList && item.removalWorkLists[n-1].removalWorkList.length">
                                                        <div class="bg_box">
                                                            <p class="title">取り外し作業</p>
                                                            <div class="form-Radio-02 label_box">
                                                                <label v-for="(removalWorkList, index) in item.removalWorkLists[n-1].removalWorkList" :key="index">
                                                                    <input type="radio" :name="item.code + '_' + n + '_removalWork'"
                                                                        :value="removalWorkList.value"
                                                                        v-model="item.selectedMakerSizeList[n-1].selectedRemovalWork">
                                                                    <span class="input_txt" :style="{backgroundColor :removalWorkList.value == item.selectedMakerSizeList[n-1].selectedRemovalWork? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :removalWorkList.value == item.selectedMakerSizeList[n-1].selectedRemovalWork? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{removalWorkList.name}}</span>
                                                                </label>
                                                            </div>
                                                            <p class="error" style="text-align:center" v-if="item.selectedMakerSizeList[n-1].requiredRemovalWork">{{$msg.ERROR.MSG_0025}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p v-if="item.unit == n && item.unit != item.maxUnit" class="no_txt"  @click="setUnit(item, n+1)">{{ item.name }}{{ n+1 }}台目<span class="icon"></span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="wrap03 btn_box">
                                    <p class="next_page">
                                        <button type="submit" class="form-Button-01 move_slide" :style="{backgroundColor : siteCodeInfo[0].NEXT_PAGE_BTN_COLOR}" data-toslide="slide3" data-movetype="next">
                                            <span v-if="mediumView">中型サイズの家電へ</span>
                                            <span v-else-if="smallView">手のひらサイズの家電へ</span>
                                            <span v-else>回収日時へ</span>
                                        </button>
                                    </p>
                                    <div class="link_box">
                                        <p class="back_page"><span class="form-Button-back move_slide" data-toslide="slide1" data-movetype="prev" @click="pageBack">戻る</span></p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LargeItems from '../../js/LargeItemsForm'
import CommonErrorMsgArea from '@/components/pc/CommonErrorMsgArea'


export default {
    props: {
        siteCodeInfo: Array,
        siteCodeItem: Array
    },
    data() {
        return {
            masterData: {
                makers: [],
                sizes: [],
                removalFees: []
            },
            items: [
                {
                    code: LargeItems.common.constant.CODE_TV,
                    name: LargeItems.common.constant.NAME_TV,
                    unit: LargeItems.common.constant.UNIT_TV,
                    maxUnit: LargeItems.common.constant.MAXUNIT_TV,
                    makerList: [],
                    sizeLists:[],
                    selectedMakerSizeList: [],
                    image: LargeItems.common.constant.IMAGE_TV_PC,
                    id:LargeItems.common.constant.ID_TV
                 },
                {
                    code: LargeItems.common.constant.CODE_FRIDGE,
                    name: LargeItems.common.constant.NAME_FRIDGE,
                    unit: LargeItems.common.constant.UNIT_FRIDGE,
                    maxUnit: LargeItems.common.constant.MAXUNIT_FRIDGE,
                    makerList: [],
                    sizeLists:[],
                    selectedMakerSizeList: [],
                    image: LargeItems.common.constant.IMAGE_FRIDGE_PC,
                    id:LargeItems.common.constant.ID_FRIDGE
                },
                {
                    code: LargeItems.common.constant.CODE_WASHER_DRYER,
                    name: LargeItems.common.constant.NAME_WASHER_DRYER,
                    unit: LargeItems.common.constant.UNIT_WASHER_DRYER,
                    maxUnit: LargeItems.common.constant.MAXUNIT_WASHER_DRYER,
                    makerList: [],
                    sizeLists:[],
                    selectedMakerSizeList: [],
                    image: LargeItems.common.constant.IMAGE_WASHER_DRYER_PC,
                    id:LargeItems.common.constant.ID_WASHER_DRYER
                 },
                {
                    code: LargeItems.common.constant.CODE_AC,
                    name: LargeItems.common.constant.NAME_AC,
                    unit: LargeItems.common.constant.UNIT_AC,
                    maxUnit: LargeItems.common.constant.MAXUNIT_AC,
                    makerList: [],
                    sizeLists:[],
                    removalWorkLists: [],
                    selectedMakerSizeList: [],
                    image: LargeItems.common.constant.IMAGE_AC_PC,
                    id:LargeItems.common.constant.ID_AC
                }
            ],
            mediumView: 0,
            smallView: 0,
            error: false,
        }
    },
    created() {
        LargeItems.inputRetention(this)
    },
    methods: {
        //大型家電のあり、なし押下時
        isExist(bool, item) {
            LargeItems.isExist(this, bool, item)
        },

        //台数追加時
        setUnit(item, num) {
            LargeItems.setUnit(this, item, num)
        },

        //台数削除時
        deleteUnit(item, num) {
            LargeItems.deleteUnit(item, num)
        },
        //メーカー取得
        getMaker(item) {
            LargeItems.getMaker(this, item)
        },
        //サイズ取得
        getSize(item, n) {
            LargeItems.getSize(this, item, n)
        },
        //次へ押下時
        submitLargeItems() {
            LargeItems.submitLargeItems(this)
        },
        //戻る押下時
        pageBack() {
            LargeItems.common.pageBack(this, LargeItems.common.constant.ADDRESS_FORM_PATH)
        },
        displayItemDescription(item) {
            return LargeItems.common.displayItemDescription(this, item)
        }
    },
    components: { CommonErrorMsgArea }
}

</script>
